import { defineComponent as n, computed as r, openBlock as l, createBlock as c, resolveDynamicComponent as m, withCtx as p, renderSlot as u } from "vue";
import { RevAvatar as i } from "@ds/components/Avatar";
import { RevButtonBase as s } from "@ds/components/ButtonBase";
const h = /* @__PURE__ */ n({
  name: "DocumentSmallAvatar",
  __name: "DocumentSmallAvatar",
  props: {
    interactive: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, o = r(
      () => t.interactive ? s : i
    );
    return (a, d) => (l(), c(m(o.value), { class: "bg-action-default-low rounded-full absolute -right-12 -top-12 grid size-24 place-content-center p-4 hover:bg-action-default-low-hover" }, {
      default: p(() => [
        u(a.$slots, "default")
      ]),
      _: 3
    }));
  }
});
export {
  h as default
};
